export default {
  modalTitle: {
    id: 'merchants_sign_terms_and_conditions_modal_title',
    defaultMessage: 'Terms & Conditions',
  },
  modalDescription: {
    id: 'merchants_sign_terms_and_conditions_modal_description',
    defaultMessage:
      'Please sign our updated Terms & Conditions and {link, html}. You need to sign them to begin selling on Back Market. 😊 ',
  },
  qualityCharterLinkName: {
    id: 'merchants_sign_terms_and_conditions_modal_quality_charter_link_name',
    defaultMessage: 'Quality Charter',
  },
  cancelButton: {
    id: 'merchants_sign_terms_and_conditions_modal_cancel_button',
    defaultMessage: 'Cancel',
  },
  goToDocuSignButton: {
    id: 'merchants_sign_terms_and_conditions_modal_docusign_button',
    defaultMessage: 'Go to DocuSign',
  },
  successToastTitle: {
    id: 'merchants_sign_terms_and_conditions_modal_docusign_success_title',
    defaultMessage: 'Thanks for signing our T&Cs.',
  },
  successToastContent: {
    id: 'merchants_sign_terms_and_conditions_modal_docusign_success_content',
    defaultMessage: 'Now let’s get to work!',
  },
}
